import Component from '@glimmer/component';
import type RecommendationModel from 'tio-data/models/recommendation';
import type IdrDashboardConrtoller from 'tio-employee/controllers/authenticated/idr/dashboard/recommendations';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import { t } from 'ember-intl';
import Button from 'tio-reimagined/components/button';
import { HStack, Section, VStack } from 'tio-reimagined/components/layout';

interface S {
  Args: {
    model: RecommendationModel;
    controller: IdrDashboardConrtoller;
  };
}

export default class IdrDashboardRecommendationsRoute extends Component<S> {
  get showConsolidationRec() {
    return this.args.controller.recommendation === 'consolidation';
  }

  get showChangeRepaymentPlanRec() {
    return this.args.controller.recommendation === 'changeRepaymentPlan';
  }

  <template>
    <TioPageBreadcrumbs class="mb-4" as |b|>
      <b.crumb @route="authenticated.idr.dashboard.index" @label="Dashboard" />
      <b.crumb @route="authenticated.idr.dashboard.recommendations" @label="Recommendations" />
    </TioPageBreadcrumbs>

    {{#if this.showConsolidationRec}}
      <VStack>
        <Section>
          <:header>
            <p>{{t "recommendations_tab.consolidate_loans"}}</p>
            <p class="text-xl mt-4">
              {{t "recommendations_tab.about_consolidation_abridged"}}
            </p>
          </:header>
          <:body>
            <p class="my-4">
              {{t "recommendations_tab.consolidation_deadline" htmlSafe=true}}
            </p>
            <HStack @collapsed={{true}}>
              <Section>
                <:header>{{t "recommendations_tab.consolidate_how.header"}}</:header>
                <:body>
                  <ol class="list-decimal list-inside">
                    <li>
                      {{t "recommendations_tab.consolidate_how.point_1" htmlSafe=true}}
                    </li>
                    <li>{{t "recommendations_tab.consolidate_how.point_2_opt2"}}</li>
                    <li>{{t "recommendations_tab.consolidate_how.point_3"}}</li>
                    <li>{{t "recommendations_tab.consolidate_how.point_4"}}</li>
                  </ol>
                </:body>
              </Section>
              <Section>
                <:header>{{t "recommendations_tab.loan_types_header"}}</:header>
                <:body>
                  <ul class="list-disc list-inside">
                    <li>
                      <span class="font-semibold">
                        {{t "recommendations_tab.ffelp"}}
                      </span>
                      {{t "recommendations_tab.ffelp_blurb"}}
                    </li>
                    <li>
                      <span class="font-semibold">
                        {{t "recommendations_tab.perkins"}}
                      </span>
                      {{t "recommendations_tab.perkins_blurb"}}
                    </li>
                  </ul>
                </:body>
              </Section>
              <Section>
                <:header>{{t "recommendations_tab.still_have_questions"}}</:header>
                <:body>
                  <p>{{t "recommendations_tab.schedule_coach" htmlSafe=true}}</p>
                </:body>
              </Section>
            </HStack>
            {{! @glint-expect-error TODO: Follow up on this. This is out of the docs, but doesn't seem to pass the class }}
            <Button @isRenderless={{true}} as |btn|>
              <a
                href="https://studentaid.gov/app/launchConsolidation.action"
                {{! @glint-expect-error TODO: Follow up on this. This is out of the docs, but doesn't seem to pass the class }}
                class="underline text-ocean-600 {{btn.classNames}}"
              >
                {{t "recommendations_tab.consolidate_loans"}}
              </a>
            </Button>
          </:body>
        </Section>
      </VStack>
    {{/if}}

    {{#if this.showChangeRepaymentPlanRec}}
      <VStack>
        <Section>
          <:header>
            <p>{{t "recommendations_tab.change_repayment_type.default"}}></p>
            <p class="text-xl mt-4">
              {{t "recommendations_tab.change_repayment_type.about_switching"}}
            </p>
          </:header>
          <:body>
            <HStack @collapsed={{true}}>
              <Section>
                <:header>{{t "recommendations_tab.change_repayment_type.q_1"}}</:header>
                <:body>{{t "recommendations_tab.change_repayment_type.a_1"}}</:body>
              </Section>
              <Section>
                <:header>{{t "recommendations_tab.change_repayment_type.q_2"}}</:header>
                <:body>
                  <ol class="list-decimal list-inside">
                    <li>
                      {{t "recommendations_tab.change_repayment_type.q_2_a_1" htmlSafe=true}}
                    </li>
                    <li>
                      {{t "recommendations_tab.change_repayment_type.q_2_a_2"}}
                    </li>
                    <li>
                      {{t "recommendations_tab.change_repayment_type.q_2_a_3" htmlSafe=true}}
                    </li>
                  </ol>
                </:body>
              </Section>
              <Section>
                <:header>{{t "recommendations_tab.still_have_questions"}}</:header>
                <:body>
                  {{t "recommendations_tab.schedule_coach" htmlSafe=true}}
                </:body>
              </Section>
            </HStack>
            {{! @glint-expect-error TODO: Follow up on this. This is out of the docs, but doesn't seem to pass the class }}
            <Button @isRenderless={{true}} as |btn|>
              <a
                href="https://studentaid.gov/manage-loans/repayment/plans"
                {{! @glint-expect-error TODO: Follow up on this. This is out of the docs, but doesn't seem to pass the class }}
                class="underline text-ocean-600 {{btn.classNames}}"
              >
                {{t "recommendations_tab.change_repayment_type.default"}}
              </a>
            </Button>
          </:body>
        </Section>
      </VStack>
    {{/if}}
  </template>
}
